import logger from "./helpers/logger";

// Environment-specific Azure AD configurations
const azureAdConfigs = {
  Dev: {
    clientId: "96bd9a88-5de7-46dd-b26e-c4dbc3a0313a",
    authority:
      "https://login.microsoftonline.com/45266ff3-8381-4642-bce6-80b91378fef1",
  },
  Test: {
    clientId:
      import.meta.env.VITE_AZURE_CLIENT_ID_TEST || "YOUR_TEST_CLIENT_ID",
    authority:
      "https://login.microsoftonline.com/45266ff3-8381-4642-bce6-80b91378fef1",
  },
  Prod: {
    clientId:
      import.meta.env.VITE_AZURE_CLIENT_ID_PROD || "YOUR_PROD_CLIENT_ID",
    authority:
      "https://login.microsoftonline.com/45266ff3-8381-4642-bce6-80b91378fef1",
  },
};

// Determine environment from VITE_ENVIRONMENT (defaults to Dev)
const environment = import.meta.env.VITE_ENVIRONMENT || "Dev";
const azureConfig = azureAdConfigs[environment] || azureAdConfigs.Dev;

logger.log(`UI Environment: ${environment}`);
logger.log(`Using Azure AD Client ID: ${azureConfig.clientId}`);

export const msalConfig = {
  auth: {
    clientId: azureConfig.clientId,
    authority: azureConfig.authority,
    redirectUri: window.location.origin, // Auto-detects environment
    navigateToLoginRequestUrl: false, // Prevents hash clearing issue
    postLogoutRedirectUri: window.location.origin + "/", // Redirects to login page after logout
  },
  cache: {
    // Using localStorage for better persistence with MFA/passkeys
    // MFA sessions benefit from persistent cache across browser sessions
    cacheLocation: "localStorage", // Changed from sessionStorage for MFA compatibility
    storeAuthStateInCookie: true, // Helps prevent issues in some browsers, especially with MFA
  },
  system: {
    // Configure to handle MFA scenarios better
    allowNativeBroker: false, // Disable native broker for web apps
    loggerOptions: {
      loggerCallback: () => {}, // Suppress MSAL internal logs (we use our own logger)
      logLevel: "Error", // Only log errors from MSAL
    },
  },
};

// Keep existing loginRequest for Microsoft Graph
export const loginRequest = {
  scopes: [
    "User.Read", // Existing scope for reading user details
  ],
};

export const authRequest = {
  scopes: [
    `api://${azureConfig.clientId}/access_as_user`,
  ],
};

export const logoutRequest = {
  postLogoutRedirectUri: window.location.origin + "/", // Ensures redirect to login after logout
};
